export default function StudentHome() {
  return (
    <div className="PortalShell">
      <header className="PortalHeader">
        <h1>Student Portal</h1>
        <p>We’ll use this space for daily check-ins, challenges, and highlights.</p>
      </header>

      <section className="Card">
        <p>Scaffold ready. Next steps: hook this into Locker Room + AI tools.</p>
      </section>
    </div>
  )
}
